export default {
	dasherize(str: string) {
		return str.trim()
			.replace(/([A-Z])/g, '-$1')
			.replace(/[-_\s]+/g, '-')
			.toLowerCase();
	}
}